import React from "react";
import { useQuery } from "@tanstack/react-query";
import AdminLayout from "@/components/admin/AdminLayout";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { listAdminQuotes } from "@/lib/api";
import { Loader2 } from "lucide-react";

const Quotes = () => {
    const { data: quotes = [], isLoading } = useQuery({
        queryKey: ["admin", "quotes"],
        queryFn: listAdminQuotes,
    });

    return (
        <AdminLayout>
            <div className="space-y-6">
                <div>
                    <h1 className="font-display text-3xl font-semibold tracking-tight">
                        Demandes de devis
                    </h1>
                    <p className="text-neutral-500 mt-1">
                        Liste des demandes reçues via le site.
                    </p>
                </div>

                <div className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Date</TableHead>
                                <TableHead>Nom</TableHead>
                                <TableHead>Contact</TableHead>
                                <TableHead>Articles</TableHead>
                                <TableHead>Ville</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={5} className="text-center py-8">
                                        <Loader2 className="w-6 h-6 animate-spin mx-auto text-[#d4af37]" />
                                    </TableCell>
                                </TableRow>
                            ) : quotes.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} className="text-center py-8 text-neutral-500">
                                        Aucune demande de devis.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                quotes.map((q) => (
                                    <TableRow key={q.id}>
                                        <TableCell className="text-sm text-neutral-500 whitespace-nowrap">
                                            {new Date(q.created_at).toLocaleString("fr-FR")}
                                        </TableCell>
                                        <TableCell className="font-medium">{q.full_name}</TableCell>
                                        <TableCell>
                                            <div className="text-sm">{q.email}</div>
                                            <div className="text-xs text-neutral-500">{q.phone}</div>
                                        </TableCell>
                                        <TableCell>
                                            <Badge variant="secondary">
                                                {q.items?.reduce((s, i) => s + i.quantity, 0) || 0} articles
                                            </Badge>
                                        </TableCell>
                                        <TableCell>{q.city || "—"}</TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </AdminLayout>
    );
};

export default Quotes;
